const SvgReboot = (props) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor">
      <path d="M17.062 1.443l-.427 3.672-3.672-.428M.841 16.527l.429-3.672 3.672.427" />
      <path d="M1.675 13.186c1.876 3.287 5.803 5.01 9.61 3.935 3.808-1.074 6.252-4.6 6.132-8.381M16.31 4.817C14.432 1.53 10.506-.193 6.699.882 2.89 1.957.446 5.482.567 9.263" />
    </g>
  </svg>
)

export default SvgReboot
